/* src/components/Reporter/Reporter.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import gql from 'nanographql';
import { onMount } from 'svelte';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import Modal from '../Modal/Modal.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[21] = list[i];
	return child_ctx;
}

// (70:0) {#if isModalOpen}
function create_if_block(ctx) {
	let modal;
	let current;

	modal = new Modal({
			props: {
				title: "Ask an Expert",
				name: "askExpert",
				id: "askExpertModal",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	modal.$on("modal-close", /*modal_close_handler*/ ctx[17]);

	return {
		c() {
			create_component(modal.$$.fragment);
		},
		l(nodes) {
			claim_component(modal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(modal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const modal_changes = {};

			if (dirty & /*$$scope, isProcessing, success, isModalOpen, question, organization, email, name, errors*/ 16778236) {
				modal_changes.$$scope = { dirty, ctx };
			}

			modal.$set(modal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(modal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(modal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(modal, detaching);
		}
	};
}

// (74:8) {#if success}
function create_if_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("Your message was successfully received.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, "Your message was successfully received.");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-success");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (78:8) {#each errors as error}
function create_each_block(ctx) {
	let div;
	let t_value = /*error*/ ctx[21].message + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, t_value);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-danger");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*errors*/ 128 && t_value !== (t_value = /*error*/ ctx[21].message + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (71:2) <Modal title="Ask an Expert" name="askExpert" id="askExpertModal" on:modal-close={() => (isModalOpen = false)}>
function create_default_slot(ctx) {
	let form;
	let div4;
	let t0;
	let t1;
	let h5;
	let t2;
	let t3;
	let p;
	let t4;
	let t5;
	let div0;
	let input0;
	let t6;
	let div1;
	let input1;
	let t7;
	let div2;
	let input2;
	let t8;
	let div3;
	let textarea;
	let t9;
	let div5;
	let button0;
	let t10;
	let t11;
	let button1;
	let t12;
	let button1_disabled_value;
	let mounted;
	let dispose;
	let if_block = /*success*/ ctx[8] && create_if_block_1(ctx);
	let each_value = /*errors*/ ctx[7];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			form = element("form");
			div4 = element("div");
			if (if_block) if_block.c();
			t0 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			h5 = element("h5");
			t2 = text("Are you a journalist or researcher writing about this topic?");
			t3 = space();
			p = element("p");
			t4 = text("Contact us and we'll connect you with an expert on our team who can provide insights and data to support your\n          work.");
			t5 = space();
			div0 = element("div");
			input0 = element("input");
			t6 = space();
			div1 = element("div");
			input1 = element("input");
			t7 = space();
			div2 = element("div");
			input2 = element("input");
			t8 = space();
			div3 = element("div");
			textarea = element("textarea");
			t9 = space();
			div5 = element("div");
			button0 = element("button");
			t10 = text("Cancel");
			t11 = space();
			button1 = element("button");
			t12 = text("Submit");
			this.h();
		},
		l(nodes) {
			form = claim_element(nodes, "FORM", {});
			var form_nodes = children(form);
			div4 = claim_element(form_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			if (if_block) if_block.l(div4_nodes);
			t0 = claim_space(div4_nodes);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div4_nodes);
			}

			t1 = claim_space(div4_nodes);
			h5 = claim_element(div4_nodes, "H5", {});
			var h5_nodes = children(h5);
			t2 = claim_text(h5_nodes, "Are you a journalist or researcher writing about this topic?");
			h5_nodes.forEach(detach);
			t3 = claim_space(div4_nodes);
			p = claim_element(div4_nodes, "P", { class: true });
			var p_nodes = children(p);
			t4 = claim_text(p_nodes, "Contact us and we'll connect you with an expert on our team who can provide insights and data to support your\n          work.");
			p_nodes.forEach(detach);
			t5 = claim_space(div4_nodes);
			div0 = claim_element(div4_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);

			input0 = claim_element(div0_nodes, "INPUT", {
				class: true,
				placeholder: true,
				type: true,
				minlength: true
			});

			div0_nodes.forEach(detach);
			t6 = claim_space(div4_nodes);
			div1 = claim_element(div4_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);

			input1 = claim_element(div1_nodes, "INPUT", {
				class: true,
				placeholder: true,
				type: true
			});

			div1_nodes.forEach(detach);
			t7 = claim_space(div4_nodes);
			div2 = claim_element(div4_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);

			input2 = claim_element(div2_nodes, "INPUT", {
				class: true,
				placeholder: true,
				type: true
			});

			div2_nodes.forEach(detach);
			t8 = claim_space(div4_nodes);
			div3 = claim_element(div4_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);

			textarea = claim_element(div3_nodes, "TEXTAREA", {
				class: true,
				placeholder: true,
				minlength: true,
				rows: true
			});

			children(textarea).forEach(detach);
			div3_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			t9 = claim_space(form_nodes);
			div5 = claim_element(form_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			button0 = claim_element(div5_nodes, "BUTTON", { type: true, class: true });
			var button0_nodes = children(button0);
			t10 = claim_text(button0_nodes, "Cancel");
			button0_nodes.forEach(detach);
			t11 = claim_space(div5_nodes);
			button1 = claim_element(div5_nodes, "BUTTON", { type: true, class: true });
			var button1_nodes = children(button1);
			t12 = claim_text(button1_nodes, "Submit");
			button1_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			form_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "svelte-k0b1bj");
			attr(input0, "class", "form-control");
			attr(input0, "placeholder", "Name");
			attr(input0, "type", "text");
			input0.required = true;
			attr(input0, "minlength", "5");
			attr(div0, "class", "form-group svelte-k0b1bj");
			attr(input1, "class", "form-control");
			attr(input1, "placeholder", "Email");
			attr(input1, "type", "email");
			input1.required = true;
			attr(div1, "class", "form-group svelte-k0b1bj");
			attr(input2, "class", "form-control");
			attr(input2, "placeholder", "Organization");
			attr(input2, "type", "text");
			attr(div2, "class", "form-group svelte-k0b1bj");
			attr(textarea, "class", "form-control");
			attr(textarea, "placeholder", "Your question");
			attr(textarea, "minlength", "8");
			attr(textarea, "rows", "4");
			textarea.required = true;
			attr(div3, "class", "form-group svelte-k0b1bj");
			attr(div4, "class", "modal-body");
			attr(button0, "type", "button");
			attr(button0, "class", "btn btn-secondary rounded svelte-k0b1bj");
			attr(button1, "type", "submit");
			attr(button1, "class", "btn btn-primary rounded svelte-k0b1bj");
			button1.disabled = button1_disabled_value = /*isProcessing*/ ctx[9] || /*success*/ ctx[8];
			attr(div5, "class", "modal-footer");
		},
		m(target, anchor) {
			insert_hydration(target, form, anchor);
			append_hydration(form, div4);
			if (if_block) if_block.m(div4, null);
			append_hydration(div4, t0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div4, null);
			}

			append_hydration(div4, t1);
			append_hydration(div4, h5);
			append_hydration(h5, t2);
			append_hydration(div4, t3);
			append_hydration(div4, p);
			append_hydration(p, t4);
			append_hydration(div4, t5);
			append_hydration(div4, div0);
			append_hydration(div0, input0);
			set_input_value(input0, /*name*/ ctx[3]);
			append_hydration(div4, t6);
			append_hydration(div4, div1);
			append_hydration(div1, input1);
			set_input_value(input1, /*email*/ ctx[4]);
			append_hydration(div4, t7);
			append_hydration(div4, div2);
			append_hydration(div2, input2);
			set_input_value(input2, /*organization*/ ctx[5]);
			append_hydration(div4, t8);
			append_hydration(div4, div3);
			append_hydration(div3, textarea);
			set_input_value(textarea, /*question*/ ctx[6]);
			append_hydration(form, t9);
			append_hydration(form, div5);
			append_hydration(div5, button0);
			append_hydration(button0, t10);
			append_hydration(div5, t11);
			append_hydration(div5, button1);
			append_hydration(button1, t12);

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[12]),
					listen(input1, "input", /*input1_input_handler*/ ctx[13]),
					listen(input2, "input", /*input2_input_handler*/ ctx[14]),
					listen(textarea, "input", /*textarea_input_handler*/ ctx[15]),
					listen(button0, "click", /*click_handler_1*/ ctx[16]),
					listen(form, "submit", prevent_default(/*sendMessage*/ ctx[10]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*success*/ ctx[8]) {
				if (if_block) {
					
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					if_block.m(div4, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*errors*/ 128) {
				each_value = /*errors*/ ctx[7];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div4, t1);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*name*/ 8 && input0.value !== /*name*/ ctx[3]) {
				set_input_value(input0, /*name*/ ctx[3]);
			}

			if (dirty & /*email*/ 16 && input1.value !== /*email*/ ctx[4]) {
				set_input_value(input1, /*email*/ ctx[4]);
			}

			if (dirty & /*organization*/ 32 && input2.value !== /*organization*/ ctx[5]) {
				set_input_value(input2, /*organization*/ ctx[5]);
			}

			if (dirty & /*question*/ 64) {
				set_input_value(textarea, /*question*/ ctx[6]);
			}

			if (dirty & /*isProcessing, success*/ 768 && button1_disabled_value !== (button1_disabled_value = /*isProcessing*/ ctx[9] || /*success*/ ctx[8])) {
				button1.disabled = button1_disabled_value;
			}
		},
		d(detaching) {
			if (detaching) detach(form);
			if (if_block) if_block.d();
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let h5;
	let t0;
	let t1;
	let p;
	let t2;
	let t3;
	let button;
	let t4;
	let button_class_value;
	let div1_class_value;
	let t5;
	let if_block_anchor;
	let current;
	let mounted;
	let dispose;
	let if_block = /*isModalOpen*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			h5 = element("h5");
			t0 = text("Are you a journalist or researcher writing about this topic?");
			t1 = space();
			p = element("p");
			t2 = text("Contact us and we'll connect you with an expert on our team who can provide insights and data to support your\n      work.");
			t3 = space();
			button = element("button");
			t4 = text("Submit Question");
			t5 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h5 = claim_element(div0_nodes, "H5", {});
			var h5_nodes = children(h5);
			t0 = claim_text(h5_nodes, "Are you a journalist or researcher writing about this topic?");
			h5_nodes.forEach(detach);
			t1 = claim_space(div0_nodes);
			p = claim_element(div0_nodes, "P", { class: true });
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Contact us and we'll connect you with an expert on our team who can provide insights and data to support your\n      work.");
			p_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t3 = claim_space(div1_nodes);
			button = claim_element(div1_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t4 = claim_text(button_nodes, "Submit Question");
			button_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t5 = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			attr(p, "class", "mb-md-0 svelte-k0b1bj");
			attr(div0, "class", "reporter-info svelte-k0b1bj");
			attr(button, "class", button_class_value = "btn " + /*buttonClasses*/ ctx[1] + " svelte-k0b1bj");
			attr(div1, "class", div1_class_value = "reporter mb-3 " + /*classes*/ ctx[0] + " svelte-k0b1bj");
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			append_hydration(div1, div0);
			append_hydration(div0, h5);
			append_hydration(h5, t0);
			append_hydration(div0, t1);
			append_hydration(div0, p);
			append_hydration(p, t2);
			append_hydration(div1, t3);
			append_hydration(div1, button);
			append_hydration(button, t4);
			insert_hydration(target, t5, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[11]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*buttonClasses*/ 2 && button_class_value !== (button_class_value = "btn " + /*buttonClasses*/ ctx[1] + " svelte-k0b1bj")) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*classes*/ 1 && div1_class_value !== (div1_class_value = "reporter mb-3 " + /*classes*/ ctx[0] + " svelte-k0b1bj")) {
				attr(div1, "class", div1_class_value);
			}

			if (/*isModalOpen*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isModalOpen*/ 4) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (detaching) detach(t5);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { classes = '' } = $$props;
	let { buttonClasses = 'btn-success' } = $$props;

	const contactForm = gql`
    mutation contactForm($email: String!, $name: String!, $message: String!) {
      contactForm(input: { email: $email, name: $name, message: $message, type: "Reporter" }) {
        response: string
      }
    }
  `;

	let isModalOpen = false;
	let name = '';
	let email = '';
	let organization = '';
	let question = '';
	let errors = [];
	let success = false;
	let isProcessing = false;
	let egKey = '';

	onMount(async () => {
		let egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	const graphql = getGraphqlClient();

	async function sendMessage() {
		$$invalidate(9, isProcessing = true);
		const org = organization ? `Organization: ${organization}; ` : '';

		let r = await graphql(
			contactForm({
				name,
				email,
				message: `${org}${question}`
			}),
			{ 'eg-key': egKey }
		);

		if (r.errors) {
			$$invalidate(7, errors = r.errors);
			$$invalidate(9, isProcessing = false);
		}

		if (r.data && r.data.contactForm && r.data.contactForm.response && r.data.contactForm.response === 'SUCCESS') {
			$$invalidate(7, errors = []);
			$$invalidate(8, success = true);
			$$invalidate(9, isProcessing = false);
		}
	}

	const click_handler = () => $$invalidate(2, isModalOpen = true);

	function input0_input_handler() {
		name = this.value;
		$$invalidate(3, name);
	}

	function input1_input_handler() {
		email = this.value;
		$$invalidate(4, email);
	}

	function input2_input_handler() {
		organization = this.value;
		$$invalidate(5, organization);
	}

	function textarea_input_handler() {
		question = this.value;
		$$invalidate(6, question);
	}

	const click_handler_1 = () => $$invalidate(2, isModalOpen = false);
	const modal_close_handler = () => $$invalidate(2, isModalOpen = false);

	$$self.$$set = $$props => {
		if ('classes' in $$props) $$invalidate(0, classes = $$props.classes);
		if ('buttonClasses' in $$props) $$invalidate(1, buttonClasses = $$props.buttonClasses);
	};

	return [
		classes,
		buttonClasses,
		isModalOpen,
		name,
		email,
		organization,
		question,
		errors,
		success,
		isProcessing,
		sendMessage,
		click_handler,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		textarea_input_handler,
		click_handler_1,
		modal_close_handler
	];
}

class Reporter extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { classes: 0, buttonClasses: 1 });
	}
}

export default Reporter;